import * as React from 'react';
import { ReactNode } from 'react';

interface Props {
  children: [ReactNode, ReactNode];
}

export const SubRow: React.FC<Props> = (props: Props): ReactNode => {
  return <div className={'flex flex-column gap-1 md:flex-row'}>
    <div className={'w-12 md:w-4'}>{props.children[0]}</div>
    <div className={'w-12 md:w-8'} style={{width: '200px'}}>{props.children[1]}</div>
  </div>;
};
